import { AirlineLiteModel } from 'api-hooks/airline';
import { CommonParamsType } from 'api-hooks/common';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { HotelLiteModel, HotelRoomModel } from 'api-hooks/hotel';
import { PreferenceTagItemModel } from 'api-hooks/preference-tag';
import { Expose, Type } from 'class-transformer';
import { CommonModel } from 'common/repositories/common.model';

export class VisaDocumentTransactionListItemModel {
  id: string;
  number: string;

  @Type(() => Number)
  total: number;
}

export class VisaDocumentTransactionListModel {
  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => VisaDocumentTransactionListItemModel)
  sales: VisaDocumentTransactionListItemModel[];

  @Type(() => VisaDocumentTransactionListItemModel)
  purchases: VisaDocumentTransactionListItemModel[];
}

export class VisaDocumentFlightsItemModel {
  id: string;

  @Type(() => AirlineLiteModel)
  airline: AirlineLiteModel;

  @Type(() => PreferenceTagItemModel)
  preference: PreferenceTagItemModel;

  route: string;
}

export class VisaDocumentFlightsModel {
  id: string;
  name: string;
  description?: string;

  @Type(() => VisaDocumentFlightsItemModel)
  items: VisaDocumentFlightsItemModel[];
}

export class VisaDocumentHotelsItemModel {
  id: string;

  @Expose({ name: 'hotel_room' })
  @Type(() => HotelRoomModel)
  hotelRoom: HotelRoomModel;

  @Expose({ name: 'city_tax' })
  cityTax?: string;

  description?: string;
}

export class VisaDocumentHotelsModel {
  id: string;

  @Type(() => HotelLiteModel)
  hotel: HotelLiteModel;

  remark?: string;

  @Type(() => VisaDocumentHotelsItemModel)
  items: VisaDocumentHotelsItemModel[];
}

export class VisaDocumentLiteModel extends CommonModel {
  code: string;
  name: string;
  description: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => Number)
  price: number;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class VisaDocumentModel extends VisaDocumentLiteModel {
  @Expose({ name: 'visa_document_flights' })
  @Type(() => VisaDocumentFlightsModel)
  visaDocumentFlights?: VisaDocumentFlightsModel[];

  @Expose({ name: 'visa_document_hotels' })
  @Type(() => VisaDocumentHotelsModel)
  visaDocumentHotels?: VisaDocumentHotelsModel[];
}

// query

export type getVisaDocumentTransactionListFilterInput = {
  transaction_at_after?: Date | null;
  transaction_at_before?: Date | null;
};

export type getVisaDocumentFilterInput = {
  name?: string;
  description?: string;
  transaction_at_after?: Date | null;
  transaction_at_before?: Date | null;
};

export type getVisaDocumentsInput = {
  params?: CommonParamsType;
};

export type getVisaDocumentInput = {
  id: string;
};

export type getVisaDocumentTransactionList = {
  id: string;
  params?: { filter?: getVisaDocumentTransactionListFilterInput };
};

// mutation
export type VisaDocumentFlightsItemMutationInput = {
  id?: string;
  airlineId: string;
  preferenceId: string;
  route: string;
};

export type VisaDocumentFlightsMutationInput = {
  id?: string;
  name: string;
  description?: string;
  items: VisaDocumentFlightsItemMutationInput[];
};

export type VisaDocumentHotelsItemMutationInput = {
  id?: string;
  hotelRoomId: string;
  cityTax?: string;
  description?: string;
};

export type VisaDocumentHotelsMutationInput = {
  id?: string;
  hotelId: string;
  remark?: string;
  items: VisaDocumentHotelsItemMutationInput[];
};

export type VisaDocumentMutationInput = {
  name: string;
  description: string;
  transactionAt: Date;
  price: number;
  visaDocumentFlights: VisaDocumentFlightsMutationInput[];
  visaDocumentHotels: VisaDocumentHotelsMutationInput[];
};

export type VisaDocumentUpdateMutationInput = {
  id: string;
  body: VisaDocumentMutationInput;
};

export type VisaDocumentDeleteMutationInput = {
  id: string;
};
